import React, { type KeyboardEvent } from 'react';

import { FormattedMessage, type MessageDescriptor } from 'react-intl-next';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button/new';
import AddIcon from '@atlaskit/icon/core/add';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex, xcss } from '@atlaskit/primitives';

import type { AddItemType } from '../../items-shared/types';

import { messages } from './messages';

const addButtonContentWrapperStyles = xcss({
	height: '20px',
});

export type AddItemButtonProps = {
	actionSubjectIdSuffix: string;
	addItem: AddItemType;
	analyticsSource: string;
	label?: MessageDescriptor;
	onAddItemKeyPress: (event: KeyboardEvent) => void;
};

export const AddItemButton = ({
	actionSubjectIdSuffix,
	analyticsSource,
	addItem,
	onAddItemKeyPress,
	label,
}: AddItemButtonProps): React.JSX.Element => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const onAddItemButtonClick = () => {
		addItem();

		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: `add${actionSubjectIdSuffix}`,
				source: analyticsSource,
			},
		}).fire();
	};

	return (
		<Button appearance="primary" onClick={onAddItemButtonClick} onKeyPress={onAddItemKeyPress}>
			<Flex
				alignItems="center"
				justifyContent="center"
				gap="space.050"
				xcss={addButtonContentWrapperStyles}
			>
				<AddIcon color="currentColor" label="" />
				<FormattedMessage {...(label || messages.addItemText)} />
			</Flex>
		</Button>
	);
};
